import React, { Component } from "react";

class PageTitle extends Component {
  render() {
    const { title, location } = this.props;
    return (
      <div className="page-tit gray">
        <div className="container location">
          {
            location ? (
              <>
                <h2 className="tit">{title}</h2>
                <span>
                  <strong>{location}</strong>
                </span>
              </>
            ) : (
              
              <strong>{title}</strong>
            )
          }
        </div>
      </div>
    );
  }
}

export default PageTitle;
